import { getAuth, GoogleAuthProvider,connectAuthEmulator,signInWithEmailAndPassword } from 'firebase/auth';
import { getFirestore, initializeFirestore, persistentLocalCache,connectFirestoreEmulator } from 'firebase/firestore';
import {getFunctions,connectFunctionsEmulator} from 'firebase/functions';
import app from './firebaseCore';

export const auth = getAuth(app);
let dbInstance;
try {
  dbInstance = initializeFirestore(app, {
    localCache: persistentLocalCache(),
  });
} catch (error) {
  dbInstance = getFirestore(app);
}
export const db = dbInstance;
export const googleProvider = new GoogleAuthProvider();

// Synthetic local acceptance builds only. The project and host guards prohibit
// accidentally redirecting a merchant project to test endpoints.
if(import.meta.env.VITE_LOCAL_EMULATORS==='true'&&app.options.projectId==='demo-workbill-phase0'&&['localhost','127.0.0.1'].includes(window.location.hostname)) {
  connectAuthEmulator(auth,'http://127.0.0.1:9190',{disableWarnings:true});
  connectFirestoreEmulator(db,'127.0.0.1',8180);
  connectFunctionsEmulator(getFunctions(app),'127.0.0.1',5001);
  window.__workbillLocalVerification={signIn:(email,password)=>signInWithEmailAndPassword(auth,email,password)};
}

export default app;
